module.exports = __webpack_public_path__ + "img/marca_UFPE_producao2_RGB-02.446f6dff.png";